export default __webpack_public_path__ + "static/media/hero-pacchetti3Medium.5996f641.jpg";